module.exports = __webpack_public_path__ + "assets/img/vtuber-ads1.f75faa4d.png";